import React from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

const Popup2 = ({ emiTc }) => {
  return (
    <section id="categories-2" className="categories-section division">
      <div className="">
        <div className="row">         
          <Popup
            className="package-terms-popup"
            trigger={
              <span className="popup13">               
                Terms and Conditions <span className="popup12">Click Here</span>
              </span>
            }
            modal
            nested
          >
            {(close) => (
              <div className="modal model1 package-terms-modal" role="dialog" aria-modal="true" aria-labelledby="package-terms-title">
                <button type="button" className="close" aria-label="Close terms and conditions" onClick={close}>
                  &times;
                </button>
                <div className="header package-terms-modal__header">
                  <span className="package-terms-modal__eyebrow">Important information</span>
                  <h3 id="package-terms-title">Terms and Conditions</h3>
                  <p>Please review these terms before proceeding with your package.</p>
                </div>
                <div className="content package-terms-modal__content">
                  <div className="package-terms-modal__document" dangerouslySetInnerHTML={{__html:emiTc}} />
                </div>
              </div>
            )}
          </Popup>          
        </div>        
      </div>      
    </section>
  );
};

export default Popup2;
